import request from "@/utils/request";
import onlyNasFileUploadUseRequest from "@/utils/onlyNasFileUploadUseRequest";

export function trainerAbsent(classId) {
  return request({
    url: `/api/teachInfo/TrainerAbsent?classId=${classId}`,
    method: "post",
  });
}

export function updateTrainClassStatus(id, comment) {
  return request({
    url: "/api/teachInfo/TrainClassStatus",
    method: "post",
    data: { id, comment },
  });
}

export function getMaterialTrainerInfo(timeFlag) {
  return request({
    url: "/api/teachInfo/MaterialTrainerInfo?timeFlag=" + timeFlag,
    method: "post",
    data: {},
  });
}

export function trainBookClassByType(classType, classTime, classTimeEnd, VideoLink) {
  return request({
    url: "/api/teachInfo/TrainBookClassByType",
    method: "post",
    data: { classType, classTime, classTimeEnd, VideoLink },
  });
}

export function GetProcessTrainingTimeList() {
  return request({
    url: "/api/training/GetProcessTrainingTimeList",
    method: "post",
    data: {},
  });
}

export function AppointmentTraining(ScheduleStart, ScheduleEnd) {
  return request({
    url: `/api/training/AppointmentTraining?ScheduleStart=${ScheduleStart}&ScheduleEnd=${ScheduleEnd}`,
    method: "post",
  });
}

export function getAClassRoomWebLink(type, isclient, roomNumber, trainingSubTypeName) {
  return request({
    url: `/api/TeachInfo/GetAClassRoomWebLink?type=${type}&trainingSubTypeName=${trainingSubTypeName}&isclient=${isclient}&roomNumber=${roomNumber}`,
    method: "post",
  });
}

export function userExtInfo() {
  return request({
    url: "/api/Account/UserExtInfo",
    method: "post",
  });
}

export function getTutorSubjectType() {
  return request({
    url: `/api/TutorComm/GetTutorSubjectType`,
    method: "post",
  });
}

export function getIsShowPopoutByContract() {
  return request({
    url: `/api/TutorComm/GetIsShowPopoutByContract`,
    method: "post",
  });
}

export function agreenPopoutByContract(isAgreen) {
  return request({
    url: `/api/TutorComm/AgreenPopoutByContract?isAgreen=${isAgreen}`,
    method: "post",
  });
}

export function getTutorHomeBanner() {
  return request({
    url: `/api/TeachInfo/GetTutorHomeBanner`,
    method: "post",
  });
}

/** Personal Data ? edit / get */

export function EditPersonalInformation(formData) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: "/api/teachInfo/EditPersonalInformation",
    method: "post",
    data: formData,
  });
}

export function EditEducationExperience(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: "/api/teachInfo/EditEducationExperience",
    method: "post",
    data,
  });
}

export function EditWorkExperience(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: `/api/teachInfo/EditWorkExperience`,
    method: "post",
    data,
  });
}

export function UpLoadLifeVideo(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/teachInfo/UpLoadLifeVideo`,
    method: "post",
    data,
  });
}

export function UpLoadLifeVideoChunk(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/teachInfo/ChunkSave`,
    method: "post",
    data,
  });
}

export function UpLoadLifeVideoMerge(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/teachInfo/FileMerge`,
    method: "post",
    data,
  });
}

export function ChunkCancel(fileCode) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/teachInfo/ChunkCancel?fileCode=${fileCode}`,
    method: "post",
  });
}

export function UpLoadLifePhoto(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: `/api/teachInfo/UpLoadLifePhoto`,
    method: "post",
    data,
  });
}

export function uploadVoiceAvatar(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/TeachInfo/UploadVoiceAvatar`,
    method: "post",
    data,
  });
}

export function uploadProfessionalIdPhoto(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/TeachInfo/UploadProfessionalIdPhoto`,
    method: "post",
    data,
  });
}

export function upLoadVirtualProfessionalPhoto(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/TeachInfo/UpLoadVirtualProfessionalPhoto`,
    method: "post",
    data,
  });
}

export function upLoadEquipmentPhoto(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/TeachInfo/UpLoadEquipmentPhoto`,
    method: "post",
    data,
  });
}

export function getLocations(parentId) {
  return request({
    url: "/api/teachInfo/Locations",
    method: "post",
    data: { parentId },
  });
}

export function getSchools() {
  return request({
    url: "/api/teachInfo/Schools",
    method: "post",
  });
}

export function editTeachLocation(parentId, locatoinName) {
  return request({
    url: `/api/teachInfo/EditTeachLocation?parentId=${parentId}&locatoinName=${locatoinName}`,
    method: "post",
  });
}

export function editTeachSchool(data) {
  return request({
    url: "/api/teachInfo/EditTeachSchool?schoolName=" + data,
    method: "post",
  });
}

export function getPersonalInformation() {
  return request({
    url: `/api/TeachInfo/PersonalInformation`,
    method: "post",
  });
}

export function getEducationExperience() {
  return request({
    url: `/api/TeachInfo/EducationExperience`,
    method: "post",
  });
}

export function getWorkExperience() {
  return request({
    url: `/api/TeachInfo/WorkExperience`,
    method: "post",
  });
}

export function getLifeShowInfo() {
  return request({
    url: `/api/TeachInfo/LifeShowInfo`,
    method: "post",
  });
}

/** Tutor leave list */
export function getTutorLeaveList(pageIndex, pageSize) {
  return request({
    url: `/api/TutorComm/GetTutorLeaveList?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: "post",
  });
}

/** Add leave request */
export function addTutorLeave(data) {
  return request({
    url: `/api/TutorComm/AddTutorLeave`,
    method: "post",
    data,
  });
}

/** Edit leave / cancel leave */
export function editTutorLeave(data) {
  return request({
    url: `/api/TutorComm/EditTutorLeave`,
    method: "post",
    data,
  });
}

/** Withdraw pending leave */
export function undoTutorLeave(id) {
  return request({
    url: `/api/TutorComm/UndoTutorLeave?id=${id}`,
    method: "post",
  });
}

/** Save contract signing data */
export function saveContractInfo(data) {
  return request({
    url: `/api/tutorcomm/SaveContractInfo`,
    method: "post",
    timeout: 5 * 60 * 1000,
    data,
  });
}

/** Load contract form / audit status */
export function getContractInfo(contractType) {
  return request({
    url: `/api/tutorcomm/GetContractInfo?contractType=${contractType}`,
    method: "post",
  });
}

/** Audit identity photos for contract HTML preview */
export function getTutorAuditInfo() {
  return request({
    url: `/api/tutorcomm/GetTutorAuditInfo`,
    method: "post",
  });
}

/** SMS OTP for contract sign */
export function sendVerificationCode(phone, countryCode) {
  return request({
    url: `/api/teachInfo/SendVerificationCode`,
    method: "post",
    timeout: 3 * 60 * 1000,
    data: { countryCode, phone },
  });
}

/** Verify SMS OTP ? AuthCode */
export function signContractVerifyCode(phone, verificationCode, countryCode) {
  return request({
    url: `/api/TutorComm/SignContractVerifyCode`,
    method: "post",
    timeout: 3 * 60 * 1000,
    data: { phone, verificationCode, countryCode },
  });
}

/** Prefill verified phone for sign dialog */
export function getSignPhoneInfo() {
  return request({
    url: `/api/TutorComm/SignPhoneInfo`,
    method: "post",
  });
}

/** Email OTP for contract sign */
export function sendEmailVerificationCode() {
  return request({
    url: `/api/teachInfo/SendVerificationCodeByEmail`,
    method: "post",
    timeout: 3 * 60 * 1000,
  });
}

/** Verify email OTP ? AuthCode (Body/Msg) */
export function signContractEmailVerifyCode(EmailCode) {
  return request({
    url: `/api/TutorComm/SignContractVerifyCodeByEmail`,
    method: "post",
    timeout: 3 * 60 * 1000,
    data: { EmailCode },
  });
}

export function getTeachingExperience() {
  return request({
    url: `/api/TeachInfo/TeachingExperience`,
    method: "post",
  });
}

export function editTeachingExperience(data) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: `/api/teachInfo/EditTeachingExperience`,
    method: "post",
    data,
  });
}

export function deleteCertificate(type) {
  return request({
    url: `/api/TeachInfo/DeleteCertificate?type=${type}`,
    method: "post",
  });
}

/** Flowers — used records */
export function getTeachAcUseRecord(pageIndex, pageSize) {
  return request({
    url: "/api/teachInfo/TeachAcUseRecord",
    method: "post",
    data: { pageIndex, pageSize },
  });
}

/** Flowers — obtained records */
export function getTeachAcRecord(pageIndex, pageSize) {
  return request({
    url: "/api/teachInfo/TeachAcRecord",
    method: "post",
    data: { pageIndex, pageSize },
  });
}

/** Flowers — convert to cash */
export function exchangeCash(flowersCount, remark) {
  return request({
    url: "/api/teachInfo/ExchangeCash",
    method: "post",
    data: { flowersCount, remark },
  });
}

/** Public Class — teacher visibility gate */
export function getIsOpenClassTeacher() {
  return request({
    url: `/api/TutorComm/GetIsOpenClassTeacher`,
    method: "post",
  });
}

/** Public Class — enter classroom link */
export function getOpenClassWebLink(classId) {
  return request({
    url: `/api/TutorComm/GetOpenClassWebLink?classId=${classId}`,
    method: "post",
  });
}

/** Public Class — schedule table */
export function getOpenClassTable(data) {
  return request({
    url: `/api/TutorComm/GetOpenClassTable`,
    method: "post",
    data,
  });
}

/** Tutor client usage log */
export function AddTutorClientUsageLog() {
  return request({
    url: `/api/TutorComm/AddTutorClientUsageLog`,
    method: "post",
  });
}

/** Referrals — dashboard stats / charts */
export function MyReferralsInfo(startTime, endTime) {
  return request({
    url: `/api/Referrals/ReferralInfo?beginDate=${startTime}&endDate=${endTime}`,
    method: "post",
  });
}

/** Referrals — list */
export function MyReferralsList(PageIndex, PageSize) {
  return request({
    url: `/api/Referrals/TeachReferralsV2?PageIndex=${PageIndex}&PageSize=${PageSize}`,
    method: "post",
  });
}

/** Referrals — personal info */
export function MyReferralsPersonal(applyId) {
  return request({
    url: `/api/Referrals/ReferralTutorInfo?applyId=${applyId}`,
    method: "post",
  });
}

/** Referrals — level change record */
export function MyReferralsLevel(applyId) {
  return request({
    url: `/api/Referrals/ReferralTutorLevelRecord?applyId=${applyId}`,
    method: "post",
  });
}

/** Referrals — bonus issue records */
export function MyReferralsBounds(applyId, PageIndex, PageSize) {
  return request({
    url: `/api/Referrals/ReferralBoundsList?applyId=${applyId}&PageIndex=${PageIndex}&PageSize=${PageSize}`,
    method: "post",
  });
}

/** Referrals — team */
export function MyReferralsTeam(applyId, PageIndex, PageSize) {
  return request({
    url: `/api/Referrals/ReferralTeam?applyId=${applyId}&PageIndex=${PageIndex}&PageSize=${PageSize}`,
    method: "post",
  });
}

/** Referrals — status track */
export function MyReferralsClass(applyId) {
  return request({
    url: `/api/Referrals/TrackLogV2?applyId=${applyId}`,
    method: "post",
  });
}

/** Referrals — share link */
export function getReferralLink() {
  return request({
    url: `/api/TutorComm/GetReferralLink`,
    method: "post",
  });
}

/** 单独添加 SkypeId（Vue2 teachinfo.addSkypeId） */
export function addSkypeId(data) {
  return request({
    url: `/api/teachInfo/EditTeachInfo`,
    method: "post",
    data,
  });
}

/** 老师端提示 skype 填写弹层（Vue2 teachinfo.isShowDialogList） */
export function isShowDialogList() {
  return request({
    url: `/api/TutorComm/ShowDialogList`,
    method: "post",
  });
}

/** 老师端迁移 / 客户端下载通知（Vue2 isShowTutorSystemTransferNotice） */
export function isShowTutorSystemTransferNotice() {
  return request({
    url: `/api/TutorComm/IsShowTutorSystemTransferNotice`,
    method: "post",
  });
}

/** 工作协议是否已同意（Vue2 getIsAgreeProtocol） */
export function getIsAgreeProtocol() {
  return request({
    url: `/api/TutorComm/GetIsAgreeProtocol`,
    method: "post",
  });
}

/** 同意工作协议（Vue2 agreeProtocolByTuid） */
export function agreeProtocolByTuid() {
  return request({
    url: `/api/TutorComm/AgreeProtocolByTuid`,
    method: "post",
  });
}

/** 绑定手机（Vue2 bindTutorPhone） */
export function bindTutorPhone(phone, verificationCode, countryCode) {
  return request({
    url: `/api/teachInfo/BindTutorPhone`,
    method: "post",
    data: { phone, verificationCode, countryCode },
  });
}

/** 绑手机 — 6 小时后再提醒（Vue2 remindMeLater） */
export function remindMeLater() {
  return request({
    url: `/api/teachInfo/RemindMeLater`,
    method: "post",
  });
}

/** 课程出勤确认列表（Vue2 getTutorAbsentMsgNew） */
export function getTutorAbsentMsgNew() {
  return request({
    url: `/api/Message/GetTutorAbsentMsgNew`,
    method: "post",
  });
}

/** 老师出勤报警通知（Vue2 AttendanceWarningByTUID） */
export function AttendanceWarningByTUID() {
  return request({
    url: `/api/AttendanceWarning/AttendanceWarningByTUID`,
    method: "post",
  });
}

/** 老师出勤报警弹窗操作 Type: 2=on time, 3=cancel（Vue2 AddAttendanceWarningPopup） */
export function AddAttendanceWarningPopup(CLID, Type) {
  return request({
    url: `/api/AttendanceWarning/AddAttendanceWarningPopup`,
    method: "post",
    data: { CLID, Type },
  });
}
